module.exports = __webpack_public_path__ + "img/signature_danielle.082268a0.png";